<template>
    
</template>

<script>
    export default {
        name: "ActivateAccount",
        props: ['user_id', 'mail_token'],
        created() {
            if (this.$auth.check()) {
                this.$router.push({name: 'account.email.activate.logged', params: {user_id: this.user_id, mail_token: this.mail_token}});
            }
            else {
                this.$router.push({name: 'account.email.activate.guest', params: {user_id: this.user_id, mail_token: this.mail_token}});
            }
        }
    }
</script>